






import Vue from "vue";

import Chart from "chart.js/auto";

interface ChartDetails {
  datasetIndex: number;
  index: number;
  label: string;
  value: string;
  x: number;
  xLabel: string;
  y: number;
  yLabel: string;
}

interface Dataset {
  data: number[];
}

interface ChartData {
  datasets: Dataset[];
  labels: string[];
}

export default Vue.extend({
  name: "LearningHistoryDoughnutChart",
  props: {
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            callbacks: {
              label: (context: any) => {
                const label = context.label;
                const value = context.dataset.data[context.dataIndex];
                return `${label}: ${value}%`;
              }
            }
          }
        },
        responsive: true
      }
    };
  },
  mounted() {
    const chart = new Chart(this.$refs.chart, {
      type: "doughnut",
      data: this.chartData,
      options: this.options
    });

    chart.canvas.parentNode.style.height = "220px";
  }
});
